import { z } from "zod";

export const AttachedFileSchema = z.object({
    uuid: z.string().uuid(),
    name: z.string(),
    extension: z.string(),
    size: z.number(),
    modifiedAt: z.date(),

    file: z.instanceof(File).optional()
});

export type AttachedFile = z.infer<typeof AttachedFileSchema>;